import { Localidade } from './localidade';
export class ServidorTodos {
  idServidor: number = 0;
  dsNomeServidor: string = '';
  dsNomeSocial: string = '';
  idCargo: number = null;
  dsCargo: string = null;
  dsEmail: string = null;
  idvinculo: number = null;
  dsVinculo: string = null;
  dsEspecialidade: string = null;
  idSituacaoFuncional: number = null;
  dsSituacaoFuncional: string = null;
  idFuncaoConfianca: number = null;
  dsFuncaoConfianca: string = null;
  idFuncaoComissionada: number = null;
  dsFuncaoComissionada: string = null;
  //idLocalidade: number = null;
  //dsLocalidade: string = null;
  nrCPF: string = null;
  nrDDD: number = null;
  nrTelefone: string = null;
  dtFim: Date = null;
  matricula: string = null;
  dsOrigem: string = null;
  localidadeEx: Localidade = null;

  constructor(d?) {
    if (d) {
      this.idServidor = d.idServidor ? d.idServidor : null;
      this.dsNomeServidor = d.dsNomeServidor ? d.dsNomeServidor : null;
      this.dsNomeSocial = d.dsNomeSocial ? d.dsNomeSocial : null;
      this.idCargo = d.idCargo ? d.idCargo : null;
      this.dsCargo = d.dsCargo ? d.dsCargo : null;
      this.dsEmail = d.dsEmail ? d.dsEmail : null;
      this.idvinculo = d.idvinculo ? d.idvinculo : null;
      this.dsVinculo = d.dsVinculo ? d.dsVinculo : null;
      this.dsEspecialidade = d.dsEspecialidade ? d.dsEspecialidade : null;
      this.idSituacaoFuncional = d.idSituacaoFuncional
        ? d.idSituacaoFuncional
        : null;
      this.dsSituacaoFuncional = d.dsSituacaoFuncional
        ? d.dsSituacaoFuncional
        : null;
      this.idFuncaoConfianca = d.idFuncaoConfianca ? d.idFuncaoConfianca : null;
      this.dsFuncaoConfianca = d.dsFuncaoConfianca ? d.dsFuncaoConfianca : null;
      this.idFuncaoComissionada = d.idFuncaoComissionada
        ? d.idFuncaoComissionada
        : null;
      this.dsFuncaoComissionada = d.dsFuncaoComissionada
        ? d.dsFuncaoComissionada
        : null;
      //this.idLocalidade = d.idLocalidade ? d.idLocalidade : null;
      //this.dsLocalidade = d.dsLocalidade ? d.dsLocalidade : null;
      this.nrCPF = d.nrCPF ? d.nrCPF : null;
      this.nrDDD = d.nrDDD ? d.nrDDD : null;
      this.nrTelefone = d.nrTelefone ? d.nrTelefone : null;
      this.dtFim = d.dtFim ? d.dtFim : null;
      this.matricula = d.matricula ? d.matricula : null;
      this.dsOrigem = d.dsOrigem ? d.dsOrigem : null;
      this.localidadeEx = d.localidadeEx
        ? new Localidade(d.localidadeEx)
        : null;
    }
  }
  /*
  getFuncao(): string {
    let funcao = '';

      if (this.dsFuncaoComissionada != null) {
        funcao = this.dsFuncaoComissionada;
      }
      if (this.dsFuncaoComissionada != null) {
        if (funcao != '') {
          funcao = funcao + ' - ' + this.dsFuncaoConfianca;
        } else {
          funcao = this.dsFuncaoConfianca;
        }
      }

    return funcao;
  }
*/
}
